import { BISKO_METHODOLOGY_ID } from "./bisko";
// BISKO_METHODOLOGY_ID is re-exported from packages/shared/src/bisko for single source of truth.
// New code should import from "@ark/shared" (barrel) or "@ark/shared/bisko" (direct).
export { BISKO_METHODOLOGY_ID };
export const METHODOLOGY_CONFIG = {
    // BISKO
    [BISKO_METHODOLOGY_ID]: {
        // Order in which sector titles appear in BISKO charts. Sectors not in this
        // list are appended after these in their input order.
        chartSectorOrder: [
            "Verkehr",
            "Industrie",
            "Gewerbe, Handel, Dienstleistung",
            "Haushalte",
            "Kommunale Einrichtungen",
        ],
        compliance: {
            emissionFactors: {
                readOnlyEnergySourceIds: [
                    "zrugky7ttlvu5qk0uagv2oj9",
                    "lpv080f56jtik30m8f1m3voa",
                    "naivjp8a72zbdfg0dzka5kh8",
                ],
                readOnlyColumns: [],
                // When true, every row in the emission-factor datagrid is read-only —
                // overrides readOnlyEnergySourceIds. BISKO compliance inventories use
                // methodology-provided factors only.
                allReadOnly: true,
            },
            energyConsumption: {
                mandatoryEnergySourceIds: [
                    "zrugky7ttlvu5qk0uagv2oj9",
                    "gwxp4qa6tr6qid0o5rem6boy",
                    "lpv080f56jtik30m8f1m3voa",
                    "my5kugikno4x13qayhrlmfka",
                    "xs0em6yxz64gq6is5y79jbal",
                    "kjfn4a6zynhvnxzqkf0zb79a",
                    "hd4dokf7pi7fifb8uni1rfdt",
                ], // Strom, Gas, Fernwärme, Heizöl, Biomasse, Solarthermie, Umweltwärme
                // For compliance inventories, data quality is controlled by data source
                dataQualityControlledByDataSource: true,
                // Transport sector specific mandatory fields for BISKO compliance
                sectorSpecificMandatory: {
                    spzzazg3jtnu2xoagttomiry: {
                        // Transport sector ID
                        mandatoryEnergySourceIds: [
                            "zrugky7ttlvu5qk0uagv2oj9", // Strom
                            "hd4dokf7pi7fifb8uni1rfdg", // Benzin
                            "pvvkz4e0x3k0eiqzuy8atwdd", // Biobenzin
                            "l1cerli2zdzgvdqrsiy8hdv8", // Diesel
                            "vao8o87ktc5upodv91znfnr3", // Diesel biogen
                            "m9hdcctw8oxguinl26ze2s2r", // Kerosin
                            "c455t6hztfxrse1rjo9m9e6i", // Bio-CNG
                            "l35s1ykikz9khecrguj8cx40", // LPG
                            "l35s1ykikz9khecrguj8cx41", // Erdgas (CNG + LNG)
                        ],
                    },
                },
            },
            dataQualitySource: {
                sectorSpecificDataQualityRequired: {
                    y5rjq7nunlt1qosz6njjx3jp: {
                        // Stationary Energy sector
                        energySourceIds: [
                            "zrugky7ttlvu5qk0uagv2oj9",
                            "gwxp4qa6tr6qid0o5rem6boy",
                            "lpv080f56jtik30m8f1m3voa",
                        ],
                        dataQualityValue: 1,
                    },
                },
            },
        },
        informational: {
            emissionFactors: {
                readOnlyEnergySourceIds: [],
                readOnlyColumns: [],
                allReadOnly: false,
            },
            dataQualitySource: {
                sectorSpecificDataQualityRequired: {},
            },
            energyConsumption: {
                mandatoryEnergySourceIds: [],
                // For informational inventories, data quality can be manually selected
                dataQualityControlledByDataSource: false,
            },
        },
    },
};
/**
 * Check if data quality is controlled by data source for a given methodology and inventory type
 * @param methodologyId - The methodology ID
 * @param isInformational - Whether the inventory is informational
 * @param dataSource - Optional data source to check if it's a custom data source
 * @returns True if data quality is controlled by data source
 */
export const isDataQualityControlledByDataSource = (methodologyId, isInformational, dataSource) => {
    const methodologyConfig = METHODOLOGY_CONFIG[methodologyId];
    if (!methodologyConfig) {
        return false;
    }
    const config = isInformational
        ? methodologyConfig.informational.energyConsumption
        : methodologyConfig.compliance.energyConsumption;
    const isControlledByDataSource = config.dataQualityControlledByDataSource ?? false;
    if (dataSource && dataSource.startsWith("Eigene Angabe")) {
        return false;
    }
    return isControlledByDataSource;
};
